import { apiFetch } from "../../api/apiFetch";
﻿export async function getMyComments(index, count) {
    let url = '/api/comments/getmycomments?index=' + index + '&count=' + count;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}


export async function getComments(targetid, index, count) {
    let url = '/api/comments/getcomments?targetid=' + targetid + "&index=" + index + "&count=" + count;
    const response = await apiFetch(url);
    if (response.status !== 200)
        return "error";
    const data = await response.json();
    if (data)
        return data;
    return null;
}



